import Vue from 'vue'
import router from '../router'
import fanyi from './language'
export default {
    provincesList:[
        {
            key: '阿迪格共和国',
            value: 'Республика Адыгея',
        },
        {
            key: '阿尔泰共和国',
            value: 'Республика Алтай',
        },
        {
            key: '巴什科尔托斯坦共和国',
            value: 'Республика Башкортостан',
        },
        {
            key: '布里亚特共和国',
            value: 'Республика Бурятия',
        },
        {
            key: '达吉斯坦共和国',
            value: 'Республика Дагестан',
        },
        {
            key: '印古什共和国',
            value: 'Республика Ингушетия',
        },
        {
            key: '卡巴尔达–巴尔卡尔共和国',
            value: 'Кабарди́но-Балка́рия',
        },
        {
            key: '卡尔梅克共和国',
            value: 'Республика Калмыкия',
        },
        {
            key: '卡拉恰伊-切尔克斯共和国',
            value: 'Карачаево-Черкесская Республика',
        },
        {
            key: '卡累利阿共和国',
            value: 'Республика Карелия',
        },
        {
            key: '科米共和国',
            value: 'Республика Коми',
        },
        {
            key: '马里埃尔共和国',
            value: 'Республика Марий Эл',
        },
        {
            key: '萨哈（雅库特）共和国',
            value: 'Республика Саха（Якутия）',
        },
        {
            key: '北奥塞梯-阿兰共和国',
            value: 'Республика Северная Осетия-Алания',
        },
        {
            key: '鞑靼斯坦共和国',
            value: 'Республика Татарстан',
        },
        {
            key: '图瓦共和国',
            value: 'Респу́блика Тыва́',
        },
        {
            key: '乌德穆尔特共和国',
            value: 'Удмуртская республика',
        },
        {
            key: '哈卡斯共和国',
            value: 'Республика Хакасия',
        },
        {
            key: '车臣共和国',
            value: 'Чеченская Республика',
        },
        {
            key: '楚瓦什自治共和国',
            value: 'Чувашская Республика',
        },{
            key: '莫尔多瓦共和国',
            value: 'Республика Мордовия',
        },
        {
            key: '克里米亚共和国',
            value: 'Крым',
        },
        {
            key: '阿尔泰边疆区',
            value: 'Алтайский край',
        },
        {
            key: '克拉斯诺达尔边疆区',
            value: 'Краснодарский край',
        },
        {
            key: '克拉斯诺亚尔斯克边疆区',
            value: 'Красноярский край',
        },
        {
            key: '滨海边疆区',
            value: 'Приморский край',
        },
        {
            key: '斯塔夫罗波尔边疆区',
            value: 'Ставропольский край',
        },
        {
            key: '哈巴罗夫斯克边疆区',
            value: 'Хабаровский край',
        },
        {
            key: '堪察加边疆区',
            value: 'Камчатский край',
        },
        {
            key: '彼尔姆边疆区',
            value: 'Пермский край',
        },
        {
            key: '后贝加尔边疆区',
            value: 'Забайкальский край',
        },
        {
            key: '阿穆尔州',
            value: 'Амурская область',
        },
        {
            key: '阿尔汉格尔斯克州',
            value: 'Архангельская область',
        },
        {
            key: '阿斯特拉罕州',
            value: 'Астраханская область',
        },
        {
            key: '别尔哥罗德州',
            value: 'Белгородская область',
        },
        {
            key: '布良斯克州',
            value: 'Брянская область',
        },
        {
            key: '弗拉基米尔州',
            value: 'Владимирская область',
        },
        {
            key: '伏尔加格勒州',
            value: 'Волгоградская область',
        },
        {
            key: '沃洛格达州',
            value: 'Вологодская область',
        },
        {
            key: '沃罗涅日州',
            value: 'Воронежская область',
        },
        {
            key: '伊万诺沃州',
            value: 'Ивановская область',
        },
        {
            key: '伊尔库茨克州',
            value: 'Иркутская область',
        },
        {
            key: '加里宁格勒州',
            value: 'Калининградская область',
        },
        {
            key: '卡卢加州',
            value: 'Калу́жская о́бласть',
        },
        {
            key: '克麦罗沃州',
            value: 'Кемеровская область',
        },
        {
            key: '基洛夫州',
            value: 'Кировская область',
        },
        {
            key: '科斯特罗马州',
            value: 'Костромская область',
        },
        {
            key: '库尔干州',
            value: 'Курганская область',
        },
        {
            key: '库尔斯克州',
            value: 'Курская область',
        },
        {
            key: '列宁格勒州',
            value: 'Ленинградская область',
        },
        {
            key: '利佩茨克州',
            value: 'Липецкая область',
        },
        {
            key: '利佩茨克州',
            value: 'Липецкая область',
        },
        {
            key: '马加丹州',
            value: 'Магаданская область',
        },
        {
            key: '莫斯科州',
            value: 'Московская область',
        },
        {
            key: '摩尔曼斯克州',
            value: 'Мурманская область',
        },
        {
            key: '下诺夫哥罗德州',
            value: 'Нижегородская область',
        },
        {
            key: '诺夫哥罗德州',
            value: 'Новгородская область',
        },
        {
            key: '新西伯利亚州',
            value: 'Новосибирская область',
        },
        {
            key: '鄂木斯克州',
            value: 'Омская область',
        },
        {
            key: '奥伦堡州',
            value: 'Оренбургская область',
        },
        {
            key: '奥廖尔州',
            value: 'Орловская область',
        },
        {
            key: '奔萨州',
            value: 'Пензенская область',
        },
        {
            key: '普斯科夫州',
            value: 'Псковская область',
        },
        {
            key: '罗斯托夫州',
            value: 'Ростовская область',
        },
        {
            key: '梁赞州',
            value: 'Рязанская область',
        },
        {
            key: '萨马拉州',
            value: 'Сама́рская о́бласть',
        },
        {
            key: '托木斯克州',
            value: 'Томская область',
        },
        {
            key: '萨拉托夫州',
            value: 'Саратовская область',
        },
        {
            key: '萨哈林州',
            value: 'Сахали́нская о́бласть',
        },
        {
            key: '斯维尔德洛夫斯克州',
            value: 'Свердловская область',
        },
        {
            key: '斯摩棱斯克州',
            value: 'Смоленская область',
        },
        {
            key: '坦波夫州',
            value: 'Тамбовская область',
        },
        {
            key: '特维尔州',
            value: 'Тверская область',
        },
        {
            key: '图拉州',
            value: 'Тульская область',
        },
        {
            key: '秋明州',
            value: 'Тюменская область',
        },
        {
            key: '乌里扬诺夫斯克州',
            value: 'Улья́новская о́бласть',
        },
        {
            key: '车里雅宾斯克州',
            value: 'Челя́бинская о́бласть',
        },
        {
            key: '雅罗斯拉夫尔州',
            value: 'Ярославская область',
        },
        {
            key: '莫斯科',
            value: 'Москва',
        },
        {
            key: '圣彼得堡',
            value: 'Санкт-Петербург',
        },
        {
            key: '塞瓦斯托波尔',
            value: 'Севастополь',
        },
        {
            key: '犹太自治州',
            value: 'Евре́йская автоно́мная о́бласть',
        },
        {
            key: '涅涅茨自治区',
            value: 'Нене́цкий автоно́мный о́круг',
        },
        {
            key: '汉特曼西斯克民族自治区',
            value: 'Ханты-Мансийский автономный округ',
        },
        {
            key: '楚科奇民族自治区',
            value: 'Чукотский автономный округ',
        },
        {
            key: '亚马尔-涅涅茨自治区',
            value: 'Ямало-Ненецкий автономный округ',
        },
    ],
}

